import Vue from 'vue'
import Router from 'vue-router'
import axios from "axios";
import i18n from "../i18n";

var selected_language = localStorage.getItem("language");
console.log("router selected language",selected_language)
if (selected_language == '' || selected_language == null) {
    i18n.locale = "en"
}else if(selected_language == "en") {
    i18n.locale = "en"
}else if(selected_language == "fa") {
    i18n.locale = "fa"
}
// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

//Base
const Branches = () => import('@/views/panel/base/Branches')
const Categories = () => import('@/views/panel/base/Categories')
const Brands = () => import('@/views/panel/base/Brands')
const ProductUnits = () => import('@/views/panel/base/ProductUnits')
const Areas = () => import('@/views/panel/base/Areas')
const Dstrict = () => import('@/views/panel/base/District')
const Places = () => import('@/views/panel/base/Places')
const PlaceUsers = () => import('@/views/panel/base/PlaceUsers')
import ProductNatures from "../views/panel/base/ProductNatures";
import OrganizationChart from "../views/panel/base/OrganizationChart";

//Products
const AddProduct = () => import('@/views/panel/products/AddProduct')
const ProductList = () => import('@/views/panel/products/ProductList')
const AddProductPrice = () => import('@/views/panel/products/AddProductPrice')
const NonOffProducts = () => import('@/views/panel/products/NonOffProducts')
const ProductReportQty = () => import('@/views/panel/products/ProductReportQty')
import InventoryOperation from "../views/panel/inventory/InventoryOperation";
//Settings
import AccountingSettings from "../views/panel/accounting/AccountingSettings";
import BuyReportComponent from "../views/panel/orders/BuyReportComponent";

//Users
const PermissionGroups = () => import('@/views/panel/users/PermissionGroups')
const AddUser = () => import('@/views/panel/users/AddUser2')
const AddSupplier = () => import('@/views/panel/orders/AddSupplier')
const AddCustomer = () => import('@/views/panel/sell/AddCustomer')
const PersonList = () => import('@/views/panel/users/PersonList')
const CustomerList = () => import('@/views/panel/sell/CustomerList')
const SupplierList = () => import('@/views/panel/orders/SupplierList')
const PersonPorsant = () => import('@/views/panel/users/PersonPorsant')
const PersonAccountingReport = () => import('@/views/panel/users/PersonAccountingReport')
const SupplierProducts = () => import('@/views/panel/orders/SupplierProducts')

//Operations
const AddDocument = () => import('@/views/panel/documents/AddDocument')
const ReturnDocument = () => import('@/views/panel/documents/ReturnDocument')
const DocumentList_backup = () => import('@/views/panel/documents/DocumentList_backup')
const DocumentList = () => import('@/views/panel/documents/DocumentList')
const ShowDocument = () => import('@/views/panel/documents/ShowDocument')
const CustomerDocument = () => import('@/views/panel/documents/CustomerDocumentList')
//Order
const AddOrder = () => import('@/views/panel/orders/AddOrder')
const OrderList = () => import('@/views/panel/orders/OrderList')


//Visitors
const VisitorAreas = () => import('@/views/panel/visitors/VisitorAreas')
const VisitorTargets = () => import('@/views/panel/visitors/VisitorTargets')
const AddVisitorTarget = () => import('@/views/panel/visitors/AddVisitorTarget')
const Drivers = () => import('@/views/panel/visitors/Drivers')
const DriverDocumentList = () => import('@/views/panel/visitors/DriverDocumentList')
const DriverReturnDocumentList = () => import('@/views/panel/visitors/DriverReturnDocumentList')
//Delivery
import DeliveryInserts from "../views/panel/delivery/DeliveryInserts";
import DeliveryOperations from "../views/panel/delivery/DeliveryOperations";

import SellFactorComponent from "../views/panel/sell/SellFactorComponent"
//Accounting
const ChequeList = () => import('@/views/panel/accounting/ChequeList')
const AccountingGroups = () => import('@/views/panel/accounting/AccountingGroups')
const AccountingGroupsLists = () => import('@/views/panel/accounting/AccountingGroupsLists')
const AccountingGroupsLists2 = () => import('@/views/panel/accounting/AccountingGroupsLists2')
const AccountingGroupsTree = () => import('@/views/panel/accounting/AccountingGroupsTree')
const DetailedAccountingGroups = () => import('@/views/panel/accounting/DetailedAccountingGroups')
const SaleMethods = () => import('@/views/panel/accounting/SaleMethods')
const SaleMethodMembers = () => import('@/views/panel/accounting/SaleMethodMembers')
const Banks = () => import('@/views/panel/accounting/Banks')
const Terminals = () => import('@/views/panel/accounting/Terminals')
const Cashiers = () => import('@/views/panel/accounting/Cashiers')
import PayOperation from "../views/panel/payOperation/PayOperation";
import ReceiveOperation from "../views/panel/receiveOperation/ReceiveOperationComponent";
import ReportPayReceiveDocs from "../views/panel/accounting/ReportPayReceiveDocs";
import AccountingPage from "../views/panel/accounting/AccountingPage";

//Settings
import Help from "../views/panel/settings/Help";
import PrintSettings from "../views/panel/settings/PrintSettings";
import Production from "../views/panel/settings/Production";
import District from "../views/panel/base/District";
import SettingsComponent from "../views/panel/settings/SettingsComponent";
import CostCenters from "../views/panel/users/CostCenters";
import BranchPositions from "../views/panel/base/BranchPositions";
import SaleSettingsComponent from "../views/panel/settings/SaleSettingsComponent";
import InventorySettingsComponent from "../views/panel/settings/InventorySettingsComponent";
import Administrative from "../views/panel/users/Administrative";
import Persons from "@/views/panel/users/Persons";
import AddOrderComponent from "../views/panel/orders/AddOrderComponent";
import CartableComponent from "../views/panel/orders/CartableComponent";
import AccountingDocumentsComponent from "@/views/panel/accounting/AccountingDocumentsComponent";
import SellProgramComponent from "../views/panel/sell/SellProgramComponent";
import CustomersComponent from "../views/panel/sell/CustomersComponent";
import ReminderComponent from "../views/panel/reminder/ReminderComponent";
import ShowAccountingDoc from "@/views/panel/accounting/ShowAccountingDoc";
import AccountingTafsiliReport from "../views/panel/reports/AccountingTafsiliReport";
import Contacts from "../views/panel/settings/Contacts";
import ReportComponent from "../views/panel/reports/ReportComponent";
import SaleReport from "@/views/panel/reports/SaleReport";
import AddDocumentCurrency from "../views/panel/documents/AddDocumentCurrency";
import AddressSettingsComponent from "../views/panel/settings/AddressSettingsComponent";
import DeliveryOperationComponent from "../views/panel/delivery/DeliveryOperationComponent";
import BuyDocumentList from "../views/panel/orders/BuyDocumentList";
import AccountingReportsComponent from "../views/panel/accounting/AccountingReportsComponent";
import ShowDocumentNew from "../views/panel/documents/ShowDocumentNew";
import AddDocumentNew from "../views/panel/documents/AddDocumentNew";
import DriverReferSupplierDocs from "../views/panel/DirectSell/DriverReferSupplierDocs";
import InsertDocSupplierDocs from "../views/panel/DirectSell/InsertDocSupplierDocs";
import DocsListSupplierDocs from "../views/panel/DirectSell/DocsListSupplierDocs";
import ShowSellDocSupplier from "../views/panel/DirectSell/ShowSellDocSupplier";
import SupplierBuyDocs from "../views/panel/orders/SupplierBuyDocs";
import SupplierBuyDocDetail from "../views/panel/orders/SupplierBuyDocDetail";
import SupplierFactors from "../views/panel/sell/SupplierFactors";
import DirectSellCustomerFactors from "../views/panel/sell/DirectSellCustomerFactors";
import ShowDirectSellFactor from "../views/panel/sell/ShowDirectSellFactor";
import SupplierDirectInvoiceDocs from "../views/panel/orders/SupplierDirectInvoiceDocs";
import InventoryReturnOperation from "../views/panel/inventory/InventoryReturnOperation";
import AddDocumentReorder from "../views/panel/documents/AddDocumentReorder";
import BuyFactorComponent from "../views/panel/orders/BuyFactorComponent";
import BuyCurrencyFactorComponent from "../views/panel/orders/BuyCurrencyFactorComponent";
import InventoryReportComponent from "../views/panel/inventory/InventoryReportComponent";
import CashBank from "../views/panel/accounting/CashBank";
import AccountCirculationReportPage from "../views/panel/accounting/Reports/AccountCirculationReportPage";
import SalaryView from "../views/panel/users/SalaryView";
import Salary from "../views/panel/users/Salary";
import PayRollList from "../views/panel/users/PayRollList";
import DeliveryReportComponent from "../views/panel/delivery/DeliveryReportComponent";
import DashboardRevenue from "@/views/dashboard/DashboardRevenue";
import DashboardSale from "@/views/dashboard/DashboardPurchase";
import DashboardCosts from "../views/dashboard/DashboardCosts";
import DashboardFinance from "@/views/dashboard/DashboardFinance";
import DashboardPurchase from "@/views/dashboard/DashboardPurchase";
import InventoryCardexQtyComponent from "../views/panel/inventory/InventoryCardexQtyComponent";
import AddDocumentPurchaseReorder from "../views/panel/documents/AddDocumentPurchaseReorder";
import BuyReportOnePersonComponent from "../views/panel/orders/BuyReportOnePersonComponent";
import AccountingReportsCardexQtyAmountComponent
    from "../views/panel/accounting/AccountingReportsCardexQtyAmountComponent";
import ReportAllEmployee from "../views/panel/users/ReportAllEmployee";
import SaleReportOneCustomer from "../views/panel/sell/SaleReportOneCustomer";
import EshantionComponent from "../views/panel/eshantion/EshantionComponent";
import InventoryAdjustmentComponent from "../views/panel/inventoryAdjustment/InventoryAdjustmentComponent";
import ShowDocumentAdjustment from "../views/panel/inventoryAdjustment/ShowDocumentAdjustment";
import ConfigGenerator from "../views/pages/ConfigGenerator";
import DataConvert from "../views/panel/settings/DataConvert.vue";
import DeliveryTrackingComponent from "../views/panel/delivery/DeliveryTrackingComponent.vue";
import DeliverySettingsComponent from "../views/panel/delivery/DeliverySettingsComponent.vue";

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const Register = () => import('@/views/pages/Register')
const BackDoor = () => import('@/views/panel/backdoor/BackdoorComponent')


Vue.use(Router)

let router = new Router({
    mode: 'history', // https://router.vuejs.org/api/#mode
    linkActiveClass: 'active',
    scrollBehavior: () => ({y: 0}),
    routes: configRoutes(),

});


export default router

router.beforeEach((to, from, next) => {
    // this.sidebar_changer= this.$refs['sidebar_ref'].$el;

    //  console.log("before each" + " token is " + localStorage.getItem('token'));
    if (to.name == null) {
        document.title = "Panel";

    } else {
        document.title = to.name;

    }
    // console.log("before each"+next);
    if (to.path == '/') {
        //  window.location.href = '/home';
    }


    if (to.matched.some(record => record.meta.requiresAuth)) {
        // console.log("validate requiresAuth");

        if (localStorage.getItem('token') == null || localStorage.getItem('token') == '') {
            //    console.log("validate is null ");

            next({
                path: 'pages/login',
                params: {nextUrl: to.fullPath}
            })
        } else {
            validate_user(next, to);


        }
    } else if (to.matched.some(record => record.meta.guest)) {
        // if(localStorage.getItem('jwt') == null){
        next();
        // }
        // else{
        //     next({ name: 'userboard'})
        // }
    } else {
        next();
    }
});


function configRoutes() {
    return [
        {
            path: '/',
            redirect: '/dashboard/main/costs',
        },
        {
            path: '/dashboard',
            name: ".dash",
            meta: {
                requiresAuth: true
            },
            component: TheContainer,
            children: [
                {
                    path: '/dashboard',
                    redirect:'/dashboard/main/costs',
                    name: i18n.t("router.dashboard"),
                    meta: {
                        requiresAuth: true,
                    },
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    // component: Dashboard,
                    children: [
                        {
                            path: 'main/revenue',
                            name: 'Dashboard Revenue',
                            component: DashboardRevenue,
                            meta: {
                                requiresAuth: true,
                            }
                        },  {
                            path: 'main/purchase',
                            name: 'Dashboard Purchase',
                            component: DashboardPurchase,
                            meta: {
                                requiresAuth: true,
                            }
                        },  {
                            path: 'main/costs',
                            name: 'Dashboard Costs',
                            component: DashboardCosts,
                            meta: {
                                requiresAuth: true,
                            }
                        },  {
                            path: 'main/financial',
                            name: 'Dashboard Financial',
                            component: DashboardFinance,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                    ]
                },
                {
                    path: '/dashboard/base',
                    redirect: '/dashboard/base/categories/0',
                    name: i18n.t("router.firstInformation"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'address/settings',
                            name: 'Address Settings',
                            component: AddressSettingsComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'settings-list',
                            name: i18n.t("BaseSettings"),
                            component: SettingsComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'reminder',
                            name: "reminder",
                            component: ReminderComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'categories/:cat_id',
                            name: i18n.t("router.categories"),
                            component: Categories,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'branches',
                            name: i18n.t("router.branches"),
                            component: Branches,
                            meta: {
                                requiresAuth: true,
                            }
                        },
                        {
                            path: 'product-units',
                            name: i18n.t("router.productUnits"),
                            component: ProductUnits,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "AddUnit"
                            }
                        },
                        {
                            path: 'brands',
                            name: i18n.t("router.brands"),
                            component: Brands,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "BrandInfo"
                            }
                        },
                        {
                            path: 'areas',
                            name: i18n.t("router.areas"),
                            component: Areas,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'districts',
                            name: i18n.t("router.districts"),
                            component: District,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'places',
                            name: i18n.t("router.warehouse"),
                            component: Places,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: '/dashboard/places/users/:place_id',
                            name: "warehouseUsers",
                            component: PlaceUsers,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'banks',
                            name: i18n.t("router.banks"),
                            component: Banks,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'terminals',
                            name: i18n.t("router.terminals"),
                            component: Terminals,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'cashiers',
                            name: i18n.t("router.cashiers"),
                            component: Cashiers,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        // {
                        //     path: '/dashboard/base/system-settings',
                        //     name: i18n.t("router.systemSettings"),
                        //     component: SystemSettings,
                        //     meta: {
                        //         requiresAuth: true,
                        //         // requiresRole: "categories"
                        //     }
                        // },
                        {
                            path: '/dashboard/base/accounting-settings',
                            name: 'Vat',
                            component: AccountingSettings,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: '/dashboard/base/organization-chart/:branch_id',
                            name: i18n.t("sidebars.organizationChart"),
                            component: OrganizationChart,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: '/dashboard/base/branch-position/:branch_id',
                            name: "Branch Positions",
                            component: BranchPositions,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: '/dashboard/base/product-natures',
                            name: i18n.t("router.productNatures"),
                            component: ProductNatures,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'cost-centers',
                            name: "Cost centers",
                            component: CostCenters,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'inventory-settings',
                            name: "Inventory Settings",
                            component: InventorySettingsComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'data-convert',
                            name: "DataConvert",
                            component: DataConvert,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }

                    ]
                },
                {
                    path: '/dashboard/products',
                    redirect: '/dashboard/products/create',
                    name: i18n.t("items"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'create',
                            name: i18n.t("router.addProduct"),
                            route_name: 'create_product',
                            component: AddProduct,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "NewProduct/Edit"
                            }
                        }, {
                            path: 'edit/:product_id',
                            name: i18n.t("router.editProduct"),
                            _name: 'edit_product',
                            component: AddProduct,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "NewProduct/Edit"
                            }
                        }, {
                            path: 'edit-price/:product_id',
                            name: i18n.t("router.editProductPrice"),
                            component: AddProductPrice,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "ProductPrice"
                            }
                        },
                        {
                            path: 'list',
                            name: i18n.t("items"),
                            component: ProductList,
                            meta: {
                                requiresAuth: true,

                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'list-cat/:cat_id',
                            name: i18n.t("router.listProductCategory"),
                            component: ProductList,
                            meta: {
                                requiresAuth: true,

                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'list-brand/:brand_id',
                            name: i18n.t("router.listProductBrand"),
                            component: ProductList,
                            meta: {
                                requiresAuth: true,

                                // requiresRole: "categories"
                            }
                        },  {
                            path: 'non-off-products',
                            name: i18n.t("router.nonOffProducts"),
                            component: NonOffProducts,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'product-existence/:product_id',
                            name: i18n.t("router.existence"),
                            component: ProductReportQty,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'inventory-operation',
                            name: "inventoryOperation",
                            component: InventoryOperation,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'inventory-reports',
                            name: "inventoryReports",
                            component: InventoryReportComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'inventory-cardex-reports/:product_name/:productid/:start_date/:end_date',
                            name: "inventoryCardexReports",
                            component: InventoryCardexQtyComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'inventory-return-operation',
                            name: "inventoryOperation",
                            component: InventoryReturnOperation,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                    ]
                },
                //**************************************
                {
                    path: '/dashboard/users',
                    name: i18n.t("router.users"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'permissions',
                            name: i18n.t("router.permissionGroups"),
                            component: PermissionGroups,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "UserGroup"
                            }
                        },
                        {
                            path: 'add-user',
                            name: i18n.t("router.addUser"),
                            component: AddUser,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'edit-user/:user_id',
                            name: i18n.t("router.editUser"),
                            component: AddUser,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'list-users',
                            name: i18n.t("router.listUsers"),
                            component: PersonList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'list-users/:area_id',
                            name: i18n.t("router.listAreaUsers"),
                            component: PersonList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'user-porsant/:person_id',
                            name: i18n.t("router.visitorCommission"),
                            component: PersonPorsant,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'user-accounting-report/:user_id',
                            name: i18n.t("router.accountingReport"),
                            component: PersonAccountingReport,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'administrative',
                            name: "administrative",
                            component: Administrative,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'payroll_list',
                            name: "payroll_list",
                            component: PayRollList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'payroll-view/:id',
                            name: "ViewPayroll",
                            component: SalaryView,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'edit-payroll/:id',
                            name: "EditPayroll",
                            component: Salary,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'persons',
                            name: "persons",
                            component: Persons,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'employee-report',
                            name: "ReportAllEmployee",
                            component: ReportAllEmployee,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                    ]
                },
                //**************************************
                {
                    path: '/dashboard/sale-orders',
                    name: "sell Orders dash",
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'add-customer',
                            name: i18n.t("components.addCustomer"),
                            component: AddCustomer,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'edit-customer/:user_id',
                            name: i18n.t("components.editCustomer"),
                            component: AddCustomer,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'list-customer',
                            name: i18n.t("saleReport"),
                            component: CustomersComponent,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "SaleReport"
                            }
                        },
                        {
                            path: 'customer-statement/:personId/:personCode/:tafsiliTypeId/:personName/:start_date/:end_date',
                            name: i18n.t("report"),
                            component: SaleReportOneCustomer,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'list-customer/:customer_report',
                            name: i18n.t("saleReport"),
                            component: CustomersComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'sale-program',
                            name: i18n.t("salesPlan"),
                            component: SellProgramComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'eshantions',
                            name: i18n.t("router.addComplimentary"),
                            component: EshantionComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'sale-invoice',
                            name: "sale invoice",
                            component: SellFactorComponent,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "SaleInvoice"
                            }
                        }, {
                            path: 'sale-reorder-invoice/:edit_doc_id',
                            name: "sale invoice",
                            component: AddDocumentReorder,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'edit-sale-invoice/:edit_doc_id',
                            name: i18n.t("router.editDocument"),
                            component: AddDocumentNew,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'reports',
                            name: "sell report",
                            component: SaleReport,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'sale-settings',
                            name: "sale settings",
                            component: SaleSettingsComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'supplier_factors',
                            name: "sale settings",
                            component: SupplierFactors,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'customer_factors',
                            name: "sale settings",
                            component: DirectSellCustomerFactors,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'show_direct_sell_factor/:doc_id',
                            name: "sale settings",
                            component: ShowDirectSellFactor,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                    ]
                },
                //**************************************
                {
                    path: '/dashboard/reports',
                    name: "reports Dash",
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'all',
                            name: 'orderList Report',
                            component: ReportComponent,
                            meta: {
                                requiresAuth: true,
                                requiresRole: "Reports"
                            }
                        }, {
                            path: 'order-list',
                            name: 'orderList',
                            component: OrderList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'tafsili',
                            name: "Reports",
                            component: AccountingTafsiliReport,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                    ]
                },
                //******************************************
                {
                    path: '/dashboard/address',
                    name: "reports Dash",
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                       {
                            path: 'order-list',
                            name: 'orderList',
                            component: OrderList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'tafsili',
                            name: "Reports",
                            component: AccountingTafsiliReport,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                    ]
                },

                //**************************************
                {
                    path: '/dashboard/documents',
                    name: i18n.t("router.operations"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [

                        {
                            path: 'create/:type_id',
                            name: i18n.t("router.addDocument"),
                            component: AddDocument,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'edit-document/:edit_doc_id',
                            name: i18n.t("router.editDocument"),
                            component: AddDocument,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'list',
                            name: "listDocuments 2",
                            component: DocumentList_backup,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'date-list',
                            name: i18n.t("router.listDocuments"),
                            component: DocumentList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'customer_docs',
                            name: "customerDocuments",
                            component: CustomerDocument,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'person-list/:person_id',
                            name: i18n.t("router.personDocuments"),
                            component: DocumentList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'show/:doc_id',
                            name: i18n.t("router.showDocument"),
                            component: ShowDocumentNew,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'return/:doc_id/:return_driver',
                            name: i18n.t("router.returnDocument"),
                            component: ReturnDocument,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                    ]
                },

//****************************************************
                {
                    path: '/dashboard/accounting',
                    name: i18n.t("sidebars.accounting"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [

                        {
                            path: 'add-accounting-doc',
                            name: "docs",
                            component: AccountingDocumentsComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'show-accounting-doc/:doc_id',
                            name: "show",
                            component: ShowAccountingDoc,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'cheque-list',
                            name: i18n.t("router.chequeList"),
                            component: ChequeList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'turnover-report/:tafsiliType/:personId/:personCode/:personName/:moein_id/:year/:date',
                            name: "Turnover Report",
                            component: AccountCirculationReportPage,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                        {
                            path: 'accounting-groups',
                            name: i18n.t("router.accountingGroups"),
                            component: AccountingGroups,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'accounting-groups-lists',
                            name: "accountingList",
                            component: AccountingGroupsLists2,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'cash-bank',
                            name: "cashBank",
                            component: CashBank,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'accounting-groups-lists2',
                            name: "accountingList2",
                            component: AccountingGroupsLists2,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'accounting-groups-tree',
                            name: "accountingList Tree",
                            component: AccountingGroupsTree,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'detailed-accounting-groups/:group_id',
                            name: i18n.t("router.DetailedAccount"),
                            component: DetailedAccountingGroups,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'sale-methods',
                            name: i18n.t("sidebars.saleMethods"),
                            component: SaleMethods,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'sale-method-members/:method_id',
                            name: i18n.t("router.saleMethodMembers"),
                            component: SaleMethodMembers,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'pay-operation',
                            name: i18n.t("router.payOperation"),
                            component: PayOperation,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'receive-operation',
                            name: i18n.t("router.receiveOperation"),
                            component: ReceiveOperation,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'pay-receive-report',
                            name: i18n.t("router.payReceiveReport"),
                            component: ReportPayReceiveDocs,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'accounting-page/:page_title',
                            name: "accounting page",
                            component: AccountingPage,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'reports',
                            name: "accounting Reports",
                            component: AccountingReportsComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'accounting-cardex-reports/:product_name/:productid/:start_date/:end_date',
                            name: "AccountingCardexReports",
                            component: AccountingReportsCardexQtyAmountComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'adjustment/show/:doc_id',
                            name: "inventorAdjustment",
                            component: ShowDocumentAdjustment,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'inventory-adjustment',
                            name: "inventorAdjustment",
                            component: InventoryAdjustmentComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                    ]
                },
//****************************************************
                {
                    path: '/dashboard/orders',
                    name: i18n.t("sidebars.orders"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'purchase-doc/:type_id',
                            name: "Supplier products",
                            component: BuyFactorComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'supplier-docs/:user_id',
                            name: "Supplier products",
                            component: SupplierDirectInvoiceDocs,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'purchase-reorder-invoice/:edit_doc_id',
                            name: "sale invoice",
                            component: AddDocumentPurchaseReorder,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'create-currency/:type_id',
                            name: "addDocument Currency",
                            component: BuyCurrencyFactorComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'edit-currency-document/:edit_doc_id',
                            name: "addDocument Currency",
                            component: AddDocumentCurrency,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'add-order',
                            name: i18n.t("buyOperation"),
                            component: AddOrderComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'cartable',
                            name: "cartable",
                            component: CartableComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                        {
                            path: 'add-supplier',
                            name: i18n.t("components.addSupplier"),
                            component: AddSupplier,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'edit-supplier/:user_id',
                            name: i18n.t("components.editSupplier"),
                            component: AddSupplier,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'list-supplier',
                            name: i18n.t("router.listSuppliers"),
                            component: SupplierList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'supplier-statement/:personId/:personCode/:tafsiliTypeId/:personName/:start_date/:end_date',
                            name: i18n.t("report"),
                            component: BuyReportOnePersonComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'supplier-products/:user_id',
                            name: "Supplier products",
                            component: SupplierProducts,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'show-supplier-doc/:doc_id',
                            name: "Supplier products",
                            component: SupplierBuyDocDetail,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'report',
                            name: "supplier report",
                            component: BuyReportComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'report/:report_type',
                            name: "supplier report",
                            component: BuyReportComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'purchase-invoices',
                            name: "buy report",
                            component: BuyDocumentList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                    ]
                },
//****************************************************
// ****************************************************
                {
                    path: '/dashboard/direct-sell',
                    name: i18n.t("sidebars.orders"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [
                        {
                            path: 'driver-products',
                            name: "driver products",
                            component: DriverReferSupplierDocs,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'insert-sell-doc',
                            name: "driver products",
                            component: InsertDocSupplierDocs,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'sale-doc-list',
                            name: "driver products",
                            component: DocsListSupplierDocs,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'show-doc/:doc_id',
                            name: "driver products",
                            component: ShowSellDocSupplier,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },

                    ]
                },
//****************************************************
                {
                    path: '/dashboard/delivery',
                    redirect: '/dashboard/delivery/areas',
                    name: i18n.t("router.visitorAndDrivers"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [

                        {
                            path: 'areas',
                            name: i18n.t("router.visitorAreas"),
                            component: VisitorAreas,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'inserts',
                            name: i18n.t("insert"),
                            component: DeliveryInserts,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'order-list',
                            name: "delivery operate",
                            component: DeliveryOperationComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'delivery-settings',
                            name: "delivery Settings",
                            component: DeliverySettingsComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'delivery-report',
                            name: "delivery Report",
                            component: DeliveryReportComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },{
                            path: 'tracking',
                            name: "Delivery Monitoring",
                            component: DeliveryTrackingComponent,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'visitor-targets',
                            name: "visitorTargets1",
                            component: VisitorTargets,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'add-visitor-target',
                            name: "router.addVisitorTarget",
                            component: AddVisitorTarget,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'drivers',
                            name: "router.drivers",
                            component: Drivers,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'driver-documents/:driverId',
                            name: "router.driverDocuments",
                            component: DriverDocumentList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'driver-return-documents/:driverId',
                            name: "router.driverReturnDocuments",
                            component: DriverReturnDocumentList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }

                    ]
                },

//****************************************************
                {
                    path: '/dashboard/settings',
                    name: i18n.t("Settings"),
                    component: {
                        render(c) {
                            return c('router-view')
                        }
                    },
                    children: [

                        {
                            path: 'help',
                            name: i18n.t("Help"),
                            component: Help,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'contacts',
                            name: "contacts",
                            component: Contacts,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'print-settings',
                            name: i18n.t("printSettings"),
                            component: PrintSettings,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'production',
                            name: i18n.t("modules.production"),
                            component: Production,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'visitor-targets',
                            name: i18n.t("router.visitorTargets"),
                            component: VisitorTargets,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'add-visitor-target',
                            name: i18n.t("router.addVisitorTarget"),
                            component: AddVisitorTarget,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        },
                        {
                            path: 'drivers',
                            name: i18n.t("router.drivers"),
                            component: Drivers,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'driver-documents/:driverId',
                            name: i18n.t("router.driverDocuments"),
                            component: DriverDocumentList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }, {
                            path: 'driver-return-documents/:driverId',
                            name: i18n.t("router.driverReturnDocuments"),
                            component: DriverReturnDocumentList,
                            meta: {
                                requiresAuth: true,
                                // requiresRole: "categories"
                            }
                        }

                    ]
                },

//****************************************************
                {
                    path: '/dashboard/backdoor',
                    name: 'BackDoor',
                    component: BackDoor,

                    children: []
                },
//****************************************************
                {
                    path: '/dashboard/help',
                    name: 'Help',
                    component: Help,

                    children: []
                },
//****************************************************
            ]
        },
        {
            path: '/pages',
            redirect: '/404',
            name: 'Pages',
            component: {
                render(c) {
                    return c('router-view')
                }
            },
            children: [
                {
                    path: '404',
                    name: 'Page404',
                    component: Page404
                },
                {
                    path: '500',
                    name: 'Page500',
                    component: Page500
                },
                {
                    path: 'login',
                    name: 'Login',
                    component: Login
                },
                {
                    path: 'register',
                    name: 'Register',
                    component: Register
                },
                {
                    path: 'config_generator',
                    name: 'config_generator',
                    component: ConfigGenerator
                }
            ]
        }
    ]
}

function validate_user(next, to) {

    let self = this;
    const formData = new FormData();
    let url;
    url = "GetUserGroupByToken";

    // formData.append('token', localStorage.getItem('token'))
    //  axios.defaults.headers.Authorization  =  'Brear '+localStorage.getItem('token');
    //  axios.defaults.headers.common['Hamid'] = "*";
    //  axios.defaults.headers.common['Authorization'] = 'Brear '+localStorage.getItem('token');
    axios.defaults.headers.post['Authorization'] = 'Bearer ' + localStorage.getItem('token');
    // axios.defaults.headers.common['Access-Control-Allow-Origin'] = "*";
    // axios.defaults.headers.common['Transfer-Encoding'] = "chunked";
    // axios.defaults.headers.common['Access-Control-Allow-Headers'] = "Origin, X-Requested-With, Content-Type, Accept, Authorization";

    axios.post(url, formData).then((res) => {
        // console.log("validate token is " + JSON.stringify(res.data));


        if (res.data.statusCode == 0) {
            let permissions = res.data.data;
            localStorage.setItem("permissions", permissions);

            //  console.log("validate is true");
            let meta_role = to.meta.requiresRole;
            // console.log("user name is "+ this.user_permissions.includes("edit_settings"));
            if (meta_role == null) {
                console.log("requiresRole is null");
                next();

            } else {
                console.log("requiresRole is " + meta_role);
                let permissions = res.data.data;
                localStorage.setItem("permissions", permissions);

                if (permissions.includes(meta_role)) {
                    console.log("user has permissions ");
                    next();

                } else {
                    next({
                        path: '/pages/404',
                        params: {nextUrl: to.fullPath}
                    });
                }

            }

        } else {
            //   console.log("validate is false last url is " + to.fullPath);
            localStorage.setItem('last_url', to.fullPath);

            next({
                path: '/pages/login',
            })
        }
        // return res.data;
    })

        // axios.post(  '/admin/category', {
        //     name: self.name,
        //     description: self.description,
        //     image: self.image,
        //     cat: 0,
        // }).then(function (response) {
        //     self.name = '';
        //     self.description = '';
        //     // localStorage.setItem("api_token", response.data.access_token);
        //     // self.$router.push({ path: 'notes' });
        // })
        .catch(function (error) {

            console.log(error);
        });
}

